<template lang="pug">
div.main-container
  v-container.mt-0.pt-0
    v-layout.mt-0(column, align-center, justify-center)
      h1.mt-0.pb-2.stepper-title Choose one to start on your way to success!
      p.mt-3.mb-4.stepper-subtitle Don't worry you will be able to do any of them later on in your crm, for now pick the one you are interested to finish your onboarding journey
  v-container.mt-0.pt-0
    v-layout.mt-0(row, align-center, justify-center)
      v-card.elevation-5.py-4.px-3.mx-4.content-card(@click="goToEmailIntegrations")
        v-container.pa-0.ma-0.text-xs-center.fill-height
          v-layout(column, align-center, justify-space-between)
            v-flex(xs3)
              p.card-title Select your provider for instant setup
            v-flex.card-middle-container(xs3)
              v-layout(row, align-center, justify-center)
                div.mx-2.px-1
                  v-img(src="/static/img/g_logo.png" height="55" width="55")
                div.mx-2.px-1
                  v-img(src="/static/img/outlook_logo.png" height="55" width="55")
                div.mx-2.px-1
                  v-img(src="/static/img/microsoft_logo_square.png" height="50" width="50")
            v-flex.pa-0.ma-0(xs2 align-end)
              div.card-bottom-container
                p.ma-0.mb-2.pa-0.card-bottom-text Sync your Contacts, Email and Calendar all in one simple process.
      v-card.elevation-5.py-4.px-3.mx-4.content-card(@click="goToImportContacts")
        v-container.pa-0.ma-0.text-xs-center.fill-height
          v-layout(column, align-center, justify-space-between)
            v-flex(xs3)
              p.mt-3.card-title Import Via CSV
            v-flex.mb-3.pb-1.card-middle-container(xs3)
              v-icon.pa-0.ma-0(size="70" color="orange accent-3") cloud_upload
            v-flex.pa-0.ma-0(xs2 align-end)
              div.card-bottom-container
                p.ma-0.pa-0.card-bottom-text Upload a CSV file of your contacts and import them directly inside of LionDesk.    
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OnboardingStep3',
  data() {
    return {
    };
  },
  methods: {
    ...mapActions('onboarding', ['finishOnboarding']),
    setStepperStage(value) {
      this.$emit('click:change', value);
    },
    async goToEmailIntegrations() {
      await this.finishOnboarding();
      this.$router.push('/email-integrations?open-drawer=true');
    },
    async goToImportContacts() {
      await this.finishOnboarding();
      this.$router.push('/contacts/import/process');
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 70vh;
}
.stepper-title {
  display: inline-block;
  font-size: 38px;
  font-weight: 500;
  line-height: 1.1;
  color: var(--v-primary-base);
}
.stepper-subtitle {
  width: 500px;
  text-align: center;
}
.content-card {
  cursor: pointer;
  border-radius: 10px;
  height: 375px;
  width: 300px;
  &--ld {
    border: 2px solid var(--v-primary-base);
  }
}
.card-title {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 220px;
  &--xs {
    font-size: 18px;
    width: 250px;
  }
}
.card-subcontainer {
  min-height: 60px;
}
.content-card-layout {
  height: 350px;
}
.card-middle-container {
  min-height: 100px;
}
.card-bottom-text {
  font-size: 13px;
  text-align: center;
  &--small {
    font-size: 12px;
    text-align: center;
  }
}
.card-bottom-container {
  min-height: 80px;
}
.continue-btn {
  font-size: 20px;
}
.skip-btn {
  font-size: 15px;
  margin-top: 0;
  color: var(--v-primary-lighten2);
}
</style>

